import axios from 'axios';

export const TEAM_PRODUCT_RECEIVED = 'TEAM_PRODUCT_RECEIVED';
export const TEAM_PRODUCT_CATEGORIES_RECEIVED = 'TEAM_PRODUCT_CATEGORIES_RECEIVED';
export const TEAM_PRODUCT_DATA_GROUPS_RECEIVED = 'TEAM_PRODUCT_DATA_GROUPS_RECEIVED';
export const TEAM_PRODUCT_PRICING_RECEIVED = 'TEAM_PRODUCT_PRICING_RECEIVED';

const getTeamProduct = (teamId, productId) => (
  dispatch => (
    axios.get(`/api/teams/${teamId}/products/${productId}`)
      .then((response) => {
        dispatch({
          type: TEAM_PRODUCT_RECEIVED,
          product: response.data.data,
        });

        dispatch({
          type: TEAM_PRODUCT_CATEGORIES_RECEIVED,
          all: response.data.categories,
        });

        dispatch({
          type: TEAM_PRODUCT_DATA_GROUPS_RECEIVED,
          all: response.data.data_groups,
        });

        dispatch({
          type: TEAM_PRODUCT_PRICING_RECEIVED,
          all: response.data.pricing,
        });
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      })
  )
);

export default getTeamProduct;
